import { Bar } from "react-chartjs-2"

import { chartColors, commonChartOptions } from "./chartConfig"
import { ChartCard, Legend, Section, type SelectOption, SelectPill } from "./components"
import { type EnterpriseChartData, selectOptions } from "./dashboardData"

import styles from "./index.module.scss"

type Props = {
  contractorOptions: SelectOption[]
  isContractorsLoading: boolean
  perftestChartOption: string
  contractorId: string
  performanceChartData: EnterpriseChartData<"bar">
  onPerftestChartOptionChange: (option: string) => void
  onContractorChange: (option: string) => void
}

export const PerformanceTestsWidget = ({
  contractorOptions,
  isContractorsLoading,
  perftestChartOption,
  contractorId,
  performanceChartData,
  onPerftestChartOptionChange,
  onContractorChange,
}: Props) => (
  <Section
    title="Performance Tests"
    controls={
      <>
        <SelectPill
          options={selectOptions.ninetyDays}
          value={perftestChartOption}
          onChange={onPerftestChartOptionChange}
        />
        <SelectPill
          options={contractorOptions}
          value={contractorId}
          disabled={isContractorsLoading}
          onChange={onContractorChange}
        />
      </>
    }
  >
    <ChartCard title="Tests Results">
      <div className={styles.largeChart}>
        <Bar data={performanceChartData} options={commonChartOptions} />
      </div>
      <Legend
        items={[
          { label: "Pass", color: chartColors.pass },
          { label: "Issue", color: chartColors.issue },
        ]}
      />
    </ChartCard>
  </Section>
)
